import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { PurchasePlusPageInfoFragmentDoc } from './PageInfo.generated'
import { PureSupplierRelationshipsSelectionDetailedSupplierFragmentDoc } from './PureSupplierRelationshipsSelectionDetailedSupplier.generated'
import * as Types from './purchasePlus_graphql'

export const GetPureSupplierRelationshipsSelectionDetailedDocument = gql`
  query GetPureSupplierRelationshipsSelectionDetailed(
    $accountsPayableSystemId: Int
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filters: SuppliersQueryFiltersInput
    $sorts: [SuppliersQuerySortsInput!]
  ) {
    accountsPayableSystem(id: $accountsPayableSystemId) {
      id
      suppliers(after: $after, before: $before, first: $first, last: $last, filters: $filters, sorts: $sorts) {
        edges {
          node {
            ...PureSupplierRelationshipsSelectionDetailedSupplier
          }
        }
        pageInfo {
          ...PurchasePlusPageInfo
        }
      }
    }
  }
  ${PureSupplierRelationshipsSelectionDetailedSupplierFragmentDoc}
  ${PurchasePlusPageInfoFragmentDoc}
` as unknown as DocumentNode<
  Types.GetPureSupplierRelationshipsSelectionDetailedQuery,
  Types.GetPureSupplierRelationshipsSelectionDetailedQueryVariables
>
